// MG Swatch Sets export: FAQs

// ✅ ONCE-ONLY LINES (copy once per file/snippet — skip if you already have these):
window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};

window.MG_SWATCH_SETS["Help-WNS-Sizes"] = {
  "meta": {
    "appearance": {
      "border_color": "#000000",
      "border_size": 2,
      "shadow_size": 0,
      "background_color": "transparent",
      "border_scope": "image",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 0,
      "text_size_desktop": 0,
      "border_radius_px": 12,
      "image_radius_px": 12,
      "product_image_padding": 0,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#000000",
      "border_size": 2,
      "shadow_size": 0,
      "background_color": "transparent",
      "border_scope": "image",
      "text_color": "",
      "text_behavior": "wrap_text",
      "text_size_mobile": 0,
      "text_size_desktop": 0,
      "border_radius_px": 12,
      "image_radius_px": 12,
      "product_image_padding": 0,
      "gradient_color": "",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<p>More Help on Sizes</p>",
      "subheading": "",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18482881888390__mg_product_swatches_FXtPR9-0",
      "custom_html": "<h4 style=\"text-align: center; font-weight: bold; font-size: 2em;\"><strong><span style=\"color: rgb(58, 108, 161);\">Let’s talk about picking the perfect amount of Retique It® for your project!</span></strong></h4>\n<div style=\"text-align: center;\"><a rel=\"noopener\" href=\"https://retique.com/products/woodnfinish_pickled-oak_s\" target=\"_blank\">\n<p style=\"text-align: left;\"><img title=\"Approximate surface coverage with a Small Retique It kit\" alt=\"Retique It Small Wood Finish Kit coverage guide\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/2_2d8c06ad-1780-43d1-878d-ee0aac74ad63.png?v=1750278905\" style=\"margin-top: 20px; margin-bottom: 20px; float: none;\"></p>\n</a><a rel=\"noopener\" href=\"https://retique.com/products/woodnfinish_pickled-oak_m\" target=\"_blank\">\n<p style=\"text-align: left;\"><img title=\"Surface area covered by a Medium Retique It wood finish kit\" alt=\"Medium Retique It Wood Finish Kit coverage\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/3_a6640783-6ff8-482c-8bb6-4639294c72f8.png?v=1750278941\" style=\"margin-bottom: 20px; float: none;\"></p>\n</a><a rel=\"noopener\" href=\"https://retique.com/products/woodnfinish_pickled-oak_l\" target=\"_blank\">\n<p style=\"text-align: left;\"><img title=\"Estimated coverage area for Large Retique It kit\" alt=\"Large Retique It Kit project coverage estimate\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/4_7f263bf0-042f-4823-9410-ac3160f3e94d.png?v=1750278975\" style=\"margin-bottom: 20px; float: none;\"></p>\n</a><a rel=\"noopener\" href=\"https://retique.com/products/woodnfinish_pickled-oak_xl\" target=\"_blank\">\n<p style=\"text-align: left;\"><img title=\"How much surface area a 4x Large Retique It kit can cover\" alt=\"Coverage for 4x Large Retique It wood finish kit\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/5_e3633daa-36f4-4a54-8fc9-441794431856.png?v=1750279017\" style=\"margin-bottom: 20px; float: none;\"><br><img title=\"How to measure square footage for Retique It DIY refinishing projects\" alt=\"Visual guide to measuring square footage for DIY Retique It projects\" src=\"https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Not_Sure_What_Size_to_Order_Presentation_43.png?v=1750278619\" style=\"margin-top: 20px; margin-bottom: 20px; float: none;\"></p>\n</a></div>",
      "custom_width_desktop_percent": "90",
      "custom_width_mobile_percent": "95",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": "0",
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Colors-WNS08"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 2,
      "shadow_size": 4,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 6,
      "product_image_padding": 2,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 8,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 4,
      "product_image_padding": 0,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "heading": "<h2>Color Options</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 30,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 10,
      "padding_between_rows": 10,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "middle",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "thumb_mode": "override",
          "product_image_id": 29402073399430,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/POAK-WNS08-7.png?v=1775235374&width=400",
          "product_url": "/products/wns-poak-s",
          "product_id": 7577010536582,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-poak-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398193864838,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-WNS08-7.png?v=1775159861&width=400",
          "product_url": "/products/wns-barn-s",
          "product_id": 7577011290246,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-barn-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "thumb_mode": "override",
          "product_image_id": 29425978638470,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-WNS08-7.png?v=1775656876&width=400",
          "product_url": "/products/wns-doak-s",
          "product_id": 7577009979526,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-doak-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398257598598,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-WNS08-7.png?v=1775162257&width=400",
          "product_url": "/products/wns-bwal-s",
          "product_id": 7577013190790,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-bwal-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "thumb_mode": "override",
          "product_image_id": 29425985618054,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-WNS08-7.png?v=1775657075&width=400",
          "product_url": "/products/wns-wwsh-s",
          "product_id": 7577010339974,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-wwsh-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "thumb_mode": "override",
          "product_image_id": 29425980309638,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DRIW-WNS08-7.png?v=1775656924&width=400",
          "product_url": "/products/wns-driw-s",
          "product_id": 7577009127558,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-driw-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398222438534,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CEDR-WNS08-7.png?v=1775161132&width=400",
          "product_url": "/products/wns-cedr-s",
          "product_id": 7577012732038,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-cedr-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398234693766,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-WNS08-7.png?v=1775161667&width=400",
          "product_url": "/products/wns-ooak-s",
          "product_id": 7577012994182,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-ooak-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398282895494,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-WNS16-7.png?v=1775163016&width=400",
          "product_url": "/products/wns-weth-s",
          "product_id": 7577013354630,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-weth-s",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<p>View All</p>",
          "button_style": "swatch",
          "button_appearance_source": "inherit_from_parent",
          "button_width_percent": 100,
          "button_max_width_px": "0",
          "button_margin_top": "10",
          "button_justify": "left",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "preset_button_heading_justify": "left",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_height_desktop": "0",
          "preset_button_border_color": "#cfcfcf",
          "preset_button_border_size": 2,
          "preset_button_shadow_size": 4,
          "preset_button_border_radius_px": 6,
          "preset_button_background_color": "#f5f5f5",
          "preset_button_text_color": "#000000",
          "preset_button_gradient_color": "#dcdfc3",
          "preset_button_gradient_angle": 42,
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_text_size_mobile": 12,
          "preset_button_text_size_desktop": 12,
          "preset_button_text_behavior": "squeeze_text",
          "preset_button_text_style": "normal",
          "preset_button_image_radius_px": 6,
          "preset_button_product_image_padding": 2,
          "preset_button_border_scope": "image_text",
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398349283462,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-WNS08-7.png?v=1775163960&width=400",
          "product_url": "/products/wns-java-s",
          "product_id": 7577014042758,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-java-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398320480390,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-WNS08-7.png?v=1775163519&width=400",
          "product_url": "/products/wns-rmgy-s",
          "product_id": 7577013682310,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-rmgy-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398181445766,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-WNS08-7.png?v=1775159283&width=400",
          "product_url": "/products/wns-doak-s-1",
          "product_id": 7577010897030,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-doak-s-1",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398203793542,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-WNS08-7.png?v=1775160436&width=400",
          "product_url": "/products/wns-char-s",
          "product_id": 7577011552390,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-char-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398053060742,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-WNS08-7.png?v=1775154656&width=400",
          "product_url": "/products/wns-cblk-s",
          "product_id": 7577008275590,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-cblk-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "thumb_mode": "override",
          "product_image_id": 29425983815814,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-WNS08-7.png?v=1775657002&width=400",
          "product_url": "/products/wns-chry-s",
          "product_id": 7577008832646,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-chry-s",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNS16"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNS08"
  },
  "rows": [
    {
      "heading": "<h2>Color Options</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398170566790,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PAOK-WNS16-1.png?v=1775158737&width=400",
          "product_url": "/products/wns-poak-m",
          "product_id": 7577010667654,
          "available": true,
          "cta": {
            "href": "/products/wns-poak-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398196551814,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-WNS16-7.png?v=1775160077&width=400",
          "product_url": "/products/wns-barn-m",
          "product_id": 7577011388550,
          "available": true,
          "cta": {
            "href": "/products/wns-barn-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "thumb_mode": "override",
          "product_image_id": 29425989320838,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-WNS16-7.png?v=1775657157&width=400",
          "product_url": "/products/wns-doak-m",
          "product_id": 7577010045062,
          "available": true,
          "cta": {
            "href": "/products/wns-doak-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398261301382,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-WNS16-7.png?v=1775162372&width=400",
          "product_url": "/products/wns-bwal-m",
          "product_id": 7577013223558,
          "available": true,
          "cta": {
            "href": "/products/wns-bwal-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "thumb_mode": "override",
          "product_image_id": 29426005966982,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-WNS16-7.png?v=1775657553&width=400",
          "product_url": "/products/wns-wwsh-m",
          "product_id": 7577010405510,
          "available": true,
          "cta": {
            "href": "/products/wns-wwsh-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "thumb_mode": "override",
          "product_image_id": 29425991057542,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DRIW-WNS16-7.png?v=1775657199&width=400",
          "product_url": "/products/wns-driw-m",
          "product_id": 7577009225862,
          "available": true,
          "cta": {
            "href": "/products/wns-driw-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398227255430,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CEDR-WNS16-7.png?v=1775161289&width=400",
          "product_url": "/products/wns-cedr-m",
          "product_id": 7577012830342,
          "available": true,
          "cta": {
            "href": "/products/wns-cedr-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398235447430,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-WNS16-7.png?v=1775161806&width=400",
          "product_url": "/products/wns-ooak-m",
          "product_id": 7577013059718,
          "available": true,
          "cta": {
            "href": "/products/wns-ooak-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398306816134,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-WNS16-7_72f1bc0f-a2e1-4706-b4b6-4ca82397f206.png?v=1775163151&width=400",
          "product_url": "/products/wns-weth-m",
          "product_id": 7577013452934,
          "available": true,
          "cta": {
            "href": "/products/wns-weth-m",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<p>View All</p>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "thumb_mode": "override",
          "product_image_id": 29426001182854,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-WNS16-7_c83e834e-53d6-4f25-be4d-553dcb103f0a.png?v=1775657457&width=400",
          "product_url": "/products/wns-java-m",
          "product_id": 7577014075526,
          "available": true,
          "cta": {
            "href": "/products/wns-java-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398323986566,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-WNS16-7.png?v=1775163602&width=400",
          "product_url": "/products/wns-rmgy-m",
          "product_id": 7577013747846,
          "available": true,
          "cta": {
            "href": "/products/wns-rmgy-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398185672838,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-WNS16-7.png?v=1775159443&width=400",
          "product_url": "/products/wns-doak-m-1",
          "product_id": 7577010962566,
          "available": true,
          "cta": {
            "href": "/products/wns-doak-m-1",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398206906502,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-WNS16-7.png?v=1775164951&width=400",
          "product_url": "/products/wns-char-m",
          "product_id": 7577011650694,
          "available": true,
          "cta": {
            "href": "/products/wns-char-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "thumb_mode": "override",
          "product_image_id": 29403950350470,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-WNS128-7.png?v=1775846492&width=400",
          "product_url": "/products/wns-cblk-m",
          "product_id": 7577008308358,
          "available": true,
          "cta": {
            "href": "/products/wns-cblk-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "thumb_mode": "override",
          "product_image_id": 29425995776134,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-WNS16-7.png?v=1775657319&width=400",
          "product_url": "/products/wns-chry-m",
          "product_id": 7577008930950,
          "available": true,
          "cta": {
            "href": "/products/wns-chry-m",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNS32"] = {
  "meta": {
    "appearance": {
      "border_color": "#767676",
      "border_size": 2,
      "shadow_size": 4,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 4,
      "product_image_padding": 2,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 90,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 10,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 4,
      "product_image_padding": 2,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 90,
      "text_style": "normal"
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "heading": "<h2>Color Options</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 20,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 10,
      "padding_between_rows": 10,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "middle",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "thumb_mode": "override",
          "product_image_id": 29403949400198,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/POAK-WNS32-7_8bb03e7f-6e53-4826-ad58-a9f628c45f14.png?v=1775846464&width=400",
          "product_url": "/products/wns-poak-l",
          "product_id": 7577010765958,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-poak-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398198812806,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-WNS32-7.png?v=1775160131&width=400",
          "product_url": "/products/wns-barn-l",
          "product_id": 7577011421318,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-barn-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "thumb_mode": "override",
          "product_image_id": 29425954062470,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-WNS32-7.png?v=1775655980&width=400",
          "product_url": "/products/wns-doak-l",
          "product_id": 7577010077830,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-doak-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398262972550,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-WNS32-7.png?v=1775162523&width=400",
          "product_url": "/products/wns-bwal-l",
          "product_id": 7577013289094,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-bwal-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "thumb_mode": "override",
          "product_image_id": 29426008293510,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-WNS32-7.png?v=1775657610&width=400",
          "product_url": "/products/wns-wwsh-l",
          "product_id": 7577010438278,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-wwsh-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "thumb_mode": "override",
          "product_image_id": 29425959796870,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DRIW-WNS32-7.png?v=1775656193&width=400",
          "product_url": "/products/wns-driw-l",
          "product_id": 7577009815686,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-driw-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398229713030,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CEDR-WNS32-7.png?v=1775161388&width=400",
          "product_url": "/products/wns-cedr-l",
          "product_id": 7577012863110,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-cedr-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398237118598,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-WNS32-7.png?v=1775161909&width=400",
          "product_url": "/products/wns-ooak-l",
          "product_id": 7577013092486,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-ooak-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398312714374,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-WNS32-7.png?v=1775163245&width=400",
          "product_url": "/products/wns-weth-l",
          "product_id": 7577013485702,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-weth-l",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<p>View All</p>",
          "button_style": "swatch",
          "button_appearance_source": "inherit_from_parent",
          "button_width_percent": 100,
          "button_max_width_px": "0",
          "button_margin_top": "10",
          "button_justify": "left",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "preset_button_heading_justify": "left",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_height_desktop": "0",
          "preset_button_border_color": "#767676",
          "preset_button_border_size": 2,
          "preset_button_shadow_size": 4,
          "preset_button_border_radius_px": 6,
          "preset_button_background_color": "#ffffff",
          "preset_button_text_color": "#000000",
          "preset_button_gradient_color": "#f5f5f5",
          "preset_button_gradient_angle": 90,
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_text_size_mobile": 12,
          "preset_button_text_size_desktop": 12,
          "preset_button_text_behavior": "truncate_text",
          "preset_button_text_style": "normal",
          "preset_button_image_radius_px": 4,
          "preset_button_product_image_padding": 2,
          "preset_button_border_scope": "image_text",
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398380380294,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-WNS32-7.png?v=1775164366&width=400",
          "product_url": "/products/wns-java-l",
          "product_id": 7577014108294,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-java-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398330081414,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-WNS32-7.png?v=1775163716&width=400",
          "product_url": "/products/wns-rmgy-l",
          "product_id": 7577013846150,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-rmgy-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398188032134,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-WNS32-7.png?v=1775159558&width=400",
          "product_url": "/products/wns-doak-l-1",
          "product_id": 7577011028102,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-doak-l-1",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398209953926,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-WNS32-7.png?v=1775160792&width=400",
          "product_url": "/products/wns-char-l",
          "product_id": 7577011683462,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-char-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "thumb_mode": "override",
          "product_image_id": 29403950350470,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-WNS128-7.png?v=1775846492&width=400",
          "product_url": "/products/wns-cblk-l",
          "product_id": 7577008341126,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-cblk-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "thumb_mode": "override",
          "product_image_id": 29425970282630,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-WNS32-7.png?v=1775656551&width=400",
          "product_url": "/products/wns-chry-l",
          "product_id": 7577009029254,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-chry-l",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNS128"] = {
  "meta": {
    "appearance": {
      "border_color": "#767676",
      "border_size": 2,
      "shadow_size": 4,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 4,
      "product_image_padding": 2,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 90,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 10,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 4,
      "product_image_padding": 2,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 90,
      "text_style": "normal"
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "heading": "<h2>Color Options</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 20,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 10,
      "padding_between_rows": 10,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "middle",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "thumb_mode": "override",
          "product_image_id": 29403949400198,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/POAK-WNS32-7_8bb03e7f-6e53-4826-ad58-a9f628c45f14.png?v=1775846464&width=400",
          "product_url": "/products/wns-poak-xl",
          "product_id": 7577010798726,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-poak-xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398202122374,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-WNS128-7.png?v=1775846121&width=400",
          "product_url": "/products/wns-barn-xl",
          "product_id": 7577011519622,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-barn-xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "thumb_mode": "override",
          "product_image_id": 29426017501318,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-WNS128-7.png?v=1775846155&width=400",
          "product_url": "/products/wns-doak-xl",
          "product_id": 7577010176134,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-doak-xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398278406278,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-WNS128-7.png?v=1775845964&width=400",
          "product_url": "/products/wns-bwal-xl",
          "product_id": 7577013321862,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-bwal-xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "thumb_mode": "override",
          "product_image_id": 29426022973574,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-WNS128-7.png?v=1775846025&width=400",
          "product_url": "/products/wns-wwsh-xl",
          "product_id": 7577010471046,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-wwsh-xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "thumb_mode": "override",
          "product_image_id": 29426024251526,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DRIW-WNS128-7.png?v=1775845996&width=400",
          "product_url": "/products/wns-driw-xl",
          "product_id": 7577009881222,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-driw-xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398231416966,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CEDR-WNS128-7.png?v=1775161486&width=400",
          "product_url": "/products/wns-cedr-xl",
          "product_id": 7577012961414,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-cedr-xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398238232710,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-WNS128-7.png?v=1775846354&width=400",
          "product_url": "/products/wns-ooak-xl",
          "product_id": 7577013125254,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-ooak-xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398317170822,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-WNS128-7.png?v=1775846201&width=400",
          "product_url": "/products/wns-weth-xl",
          "product_id": 7577013616774,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-weth-xl",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<p>View All</p>",
          "button_style": "swatch",
          "button_appearance_source": "inherit_from_parent",
          "button_width_percent": 100,
          "button_max_width_px": "0",
          "button_margin_top": "10",
          "button_justify": "left",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "preset_button_heading_justify": "left",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_height_desktop": "0",
          "preset_button_border_color": "#767676",
          "preset_button_border_size": 2,
          "preset_button_shadow_size": 4,
          "preset_button_border_radius_px": 6,
          "preset_button_background_color": "#ffffff",
          "preset_button_text_color": "#000000",
          "preset_button_gradient_color": "#f5f5f5",
          "preset_button_gradient_angle": 90,
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_text_size_mobile": 12,
          "preset_button_text_size_desktop": 12,
          "preset_button_text_behavior": "truncate_text",
          "preset_button_text_style": "normal",
          "preset_button_image_radius_px": 4,
          "preset_button_product_image_padding": 2,
          "preset_button_border_scope": "image_text",
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398383853702,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-WNS128-7.png?v=1775846083&width=400",
          "product_url": "/products/wns-java-xl",
          "product_id": 7577014141062,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-java-xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398337421446,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-WNS128-7.png?v=1775846302&width=400",
          "product_url": "/products/wns-rmgy-xl",
          "product_id": 7577013911686,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-rmgy-xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398189965446,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-WNS128-7.png?v=1775846405&width=400",
          "product_url": "/products/wns-doak-xl-1",
          "product_id": 7577011060870,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-doak-xl-1",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "thumb_mode": "override",
          "product_image_id": 29398214148230,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-WNS128-7.png?v=1775845935&width=400",
          "product_url": "/products/wns-char-xl",
          "product_id": 7577011847302,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-char-xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "thumb_mode": "override",
          "product_image_id": 29403950350470,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-WNS128-7.png?v=1775846492&width=400",
          "product_url": "/products/wns-cblk-xl",
          "product_id": 7577008406662,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-cblk-xl",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "thumb_mode": "override",
          "product_image_id": 29426028019846,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-WNS128-7.png?v=1775846228&width=400",
          "product_url": "/products/wns-chry-xl",
          "product_id": 7577009062022,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-chry-xl",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNS-POAK"] = {
  "meta": {
    "match_settings_preset_key": "Colors-WNK08"
  },
  "rows": [
    {
      "heading": "<h3>Pickled Oak Size Options</h3>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/POAK-WNS08-1.png?v=1775158620&width=400",
          "product_url": "/products/wns-poak-s",
          "product_id": 7577010536582,
          "available": true,
          "cta": {
            "href": "/products/wns-poak-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PAOK-WNS16-1.png?v=1775158737&width=400",
          "product_url": "/products/wns-poak-m",
          "product_id": 7577010667654,
          "available": true,
          "cta": {
            "href": "/products/wns-poak-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/POAK-WNS32-1.png?v=1775158842&width=400",
          "product_url": "/products/wns-poak-l",
          "product_id": 7577010765958,
          "available": true,
          "cta": {
            "href": "/products/wns-poak-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_3D_840326bc-12fc-4c4b-92b8-a6f5885be6ef.png?v=1775846464&width=400",
          "product_url": "/products/wns-poak-xl",
          "product_id": 7577010798726,
          "available": true,
          "cta": {
            "href": "/products/wns-poak-xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18541426212998__mg_product_swatches_G4hXRR-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNS-BARN"] = {
  "meta": {
    "appearance": {
      "border_color": "#969696",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 6,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#e7e7e7",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h3>Barn Wood Size Options</h3>",
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-WNS08-1.png?v=1775159861&width=400",
          "product_url": "/products/wns-barn-s",
          "product_id": 7577011290246,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-barn-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-WNS16-1.png?v=1775160077&width=400",
          "product_url": "/products/wns-barn-m",
          "product_id": 7577011388550,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-barn-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-WNS32-1.png?v=1775160118&width=400",
          "product_url": "/products/wns-barn-l",
          "product_id": 7577011421318,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-barn-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_3D_972d766d-ef5d-4e53-9c73-fa376cd4c54e.png?v=1775846121&width=400",
          "product_url": "/products/wns-barn-xl",
          "product_id": 7577011519622,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-barn-xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426212998__mg_product_swatches_XBaJ4r-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNS-DOAK"] = {
  "meta": {
    "appearance": {
      "border_color": "#969696",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 6,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#e7e7e7",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h3>Dark Oak Size Options</h3>",
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-WNS08-1.png?v=1775156775&width=400",
          "product_url": "/products/wns-doak-s",
          "product_id": 7577009979526,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-doak-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-WNS16-1.png?v=1775156971&width=400",
          "product_url": "/products/wns-doak-m",
          "product_id": 7577010045062,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-doak-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-WNS32-1.png?v=1775157382&width=400",
          "product_url": "/products/wns-doak-l",
          "product_id": 7577010077830,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-doak-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_3D_9c328c8a-f72a-44cc-a214-cfb6cc0d492e.png?v=1775846155&width=400",
          "product_url": "/products/wns-doak-xl",
          "product_id": 7577010176134,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-doak-xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426212998__mg_product_swatches_UrMBhz-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNS-BWAL"] = {
  "meta": {
    "appearance": {
      "border_color": "#969696",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 6,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#e7e7e7",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h3>Black Walnut Size Options</h3>",
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-WNS08-1.png?v=1775162257&width=400",
          "product_url": "/products/wns-bwal-s",
          "product_id": 7577013190790,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-bwal-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-WNS16-1.png?v=1775162415&width=400",
          "product_url": "/products/wns-bwal-m",
          "product_id": 7577013223558,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-bwal-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-WNS32-1.png?v=1775162523&width=400",
          "product_url": "/products/wns-bwal-l",
          "product_id": 7577013289094,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-bwal-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_3D_6f9796f9-031f-410c-984d-8d6ee5655892.png?v=1775845964&width=400",
          "product_url": "/products/wns-bwal-xl",
          "product_id": 7577013321862,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-bwal-xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426212998__mg_product_swatches_QXydmC-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNS-WWSH"] = {
  "meta": {
    "appearance": {
      "border_color": "#969696",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 6,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#e7e7e7",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h3>White Wash Size Options</h3>",
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-WNS08-1.png?v=1775157946&width=400",
          "product_url": "/products/wns-wwsh-s",
          "product_id": 7577010339974,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-wwsh-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-WNS16-1.png?v=1775158037&width=400",
          "product_url": "/products/wns-wwsh-m",
          "product_id": 7577010405510,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-wwsh-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-WNS32-1.png?v=1775158202&width=400",
          "product_url": "/products/wns-wwsh-l",
          "product_id": 7577010438278,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-wwsh-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_3D_e6c2df8f-3c4f-411e-b176-ecb061259401.png?v=1775846025&width=400",
          "product_url": "/products/wns-wwsh-xl",
          "product_id": 7577010471046,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-wwsh-xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426212998__mg_product_swatches_Wcwe8r-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNS-DRIW"] = {
  "meta": {
    "appearance": {
      "border_color": "#969696",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 6,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#e7e7e7",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h3>Drift Wood Size Options</h3>",
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DRIW-WNS08-1.png?v=1775156278&width=400",
          "product_url": "/products/wns-driw-s",
          "product_id": 7577009127558,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-driw-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DRIW-WNS16-1.png?v=1775156403&width=400",
          "product_url": "/products/wns-driw-m",
          "product_id": 7577009225862,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-driw-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DRIW-WNS32-1.png?v=1775156513&width=400",
          "product_url": "/products/wns-driw-l",
          "product_id": 7577009815686,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-driw-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_3D_9e119589-6d4e-458b-b634-030d7068b68d.png?v=1775845996&width=400",
          "product_url": "/products/wns-driw-xl",
          "product_id": 7577009881222,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-driw-xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426212998__mg_product_swatches_7WHHzh-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNS-CEDR"] = {
  "meta": {
    "appearance": {
      "border_color": "#969696",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 6,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#e7e7e7",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h3>Cedar Size Options</h3>",
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CEDR-WNS08-1.png?v=1775161132&width=400",
          "product_url": "/products/wns-cedr-s",
          "product_id": 7577012732038,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-cedr-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CEDR-WNS16-1.png?v=1775161289&width=400",
          "product_url": "/products/wns-cedr-m",
          "product_id": 7577012830342,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-cedr-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CEDR-WNS32-1.png?v=1775161388&width=400",
          "product_url": "/products/wns-cedr-l",
          "product_id": 7577012863110,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-cedr-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CEDR-WNS128-2.png?v=1775161486&width=400",
          "product_url": "/products/wns-cedr-xl",
          "product_id": 7577012961414,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-cedr-xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426212998__mg_product_swatches_VfKgfi-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNS-OOAK"] = {
  "meta": {
    "appearance": {
      "border_color": "#969696",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 6,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#e7e7e7",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h3>Old Oak Size Options</h3>",
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-WNS08-1.png?v=1775161667&width=400",
          "product_url": "/products/wns-ooak-s",
          "product_id": 7577012994182,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-ooak-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-WNS16-1.png?v=1775161806&width=400",
          "product_url": "/products/wns-ooak-m",
          "product_id": 7577013059718,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-ooak-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-WNS32-1.png?v=1775161909&width=400",
          "product_url": "/products/wns-ooak-l",
          "product_id": 7577013092486,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-ooak-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_3D_ac2d6d77-3306-4777-a731-7dc0d8c052b0.png?v=1775846354&width=400",
          "product_url": "/products/wns-ooak-xl",
          "product_id": 7577013125254,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-ooak-xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426212998__mg_product_swatches_Q47tyf-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNS-WETH"] = {
  "meta": {
    "appearance": {
      "border_color": "#969696",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 6,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#e7e7e7",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h3>Weathered Wood Size Options</h3>",
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-WNS08-1.png?v=1775163016&width=400",
          "product_url": "/products/wns-weth-s",
          "product_id": 7577013354630,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-weth-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-WNS16-1_d88beca0-5355-4718-b402-bb3ac02ca573.png?v=1775163151&width=400",
          "product_url": "/products/wns-weth-m",
          "product_id": 7577013452934,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-weth-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-WNS32-1.png?v=1775163245&width=400",
          "product_url": "/products/wns-weth-l",
          "product_id": 7577013485702,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-weth-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_3D_0489b4f6-124b-461b-8d40-9fab7be03db9.png?v=1775846201&width=400",
          "product_url": "/products/wns-weth-xl",
          "product_id": 7577013616774,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-weth-xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426212998__mg_product_swatches_dDRnmE-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNS-JAVA"] = {
  "meta": {
    "appearance": {
      "border_color": "#969696",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 6,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#e7e7e7",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h3>Java Size Options</h3>",
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-WNS08-1.png?v=1775163960&width=400",
          "product_url": "/products/wns-java-s",
          "product_id": 7577014042758,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-java-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-WNS16-1_92e94117-4876-4c86-87ff-2a7d3a46b4e1.png?v=1775164155&width=400",
          "product_url": "/products/wns-java-m",
          "product_id": 7577014075526,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-java-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-WNS32-1.png?v=1775164366&width=400",
          "product_url": "/products/wns-java-l",
          "product_id": 7577014108294,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-java-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_3D_737bea3f-8b12-4db2-8146-1cbb8447be33.png?v=1775846083&width=400",
          "product_url": "/products/wns-java-xl",
          "product_id": 7577014141062,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-java-xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426212998__mg_product_swatches_fj9J47-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNS-RMGY"] = {
  "meta": {
    "appearance": {
      "border_color": "#969696",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 6,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#e7e7e7",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h3>Red Mahogany Size Options</h3>",
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-WNS08-1.png?v=1775163519&width=400",
          "product_url": "/products/wns-rmgy-s",
          "product_id": 7577013682310,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-rmgy-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-WNS16-1.png?v=1775163602&width=400",
          "product_url": "/products/wns-rmgy-m",
          "product_id": 7577013747846,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-rmgy-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-WNS32-1.png?v=1775163716&width=400",
          "product_url": "/products/wns-rmgy-l",
          "product_id": 7577013846150,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-rmgy-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_3D_2638c5cc-7a26-4dc2-9e6b-190530f6b6ec.png?v=1775846302&width=400",
          "product_url": "/products/wns-rmgy-xl",
          "product_id": 7577013911686,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-rmgy-xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426212998__mg_product_swatches_GBTGDa-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNS-PECA"] = {
  "meta": {
    "appearance": {
      "border_color": "#969696",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 6,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#e7e7e7",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h3>Dark Pecan Size Options</h3>",
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-WNS08-1.png?v=1775159271&width=400",
          "product_url": "/products/wns-doak-s-1",
          "product_id": 7577010897030,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-doak-s-1",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-WNS16-1.png?v=1775159405&width=400",
          "product_url": "/products/wns-doak-m-1",
          "product_id": 7577010962566,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-doak-m-1",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-WNS32-1.png?v=1775159503&width=400",
          "product_url": "/products/wns-doak-l-1",
          "product_id": 7577011028102,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-doak-l-1",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_3D_23484443-d7b4-44d6-97f1-37d8d885bf9b.png?v=1775846405&width=400",
          "product_url": "/products/wns-doak-xl-1",
          "product_id": 7577011060870,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-doak-xl-1",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426212998__mg_product_swatches_BtNqaV-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNS-CHAR"] = {
  "meta": {
    "appearance": {
      "border_color": "#969696",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 6,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#e7e7e7",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h3>Charcoal Size Options</h3>",
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-WNS08-1.png?v=1775160436&width=400",
          "product_url": "/products/wns-char-s",
          "product_id": 7577011552390,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-char-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-WNS16-1.png?v=1775160647&width=400",
          "product_url": "/products/wns-char-m",
          "product_id": 7577011650694,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-char-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-WNS32-1.png?v=1775160792&width=400",
          "product_url": "/products/wns-char-l",
          "product_id": 7577011683462,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-char-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_3D.png?v=1775845935&width=400",
          "product_url": "/products/wns-char-xl",
          "product_id": 7577011847302,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-char-xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426212998__mg_product_swatches_mqVtb7-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNS-CBLK"] = {
  "meta": {
    "appearance": {
      "border_color": "#969696",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 6,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#e7e7e7",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h3>Classic Black Size Options</h3>",
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-WNS08-1.png?v=1775154957&width=400",
          "product_url": "/products/wns-cblk-s",
          "product_id": 7577008275590,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-cblk-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-WNS16-1.png?v=1775155149&width=400",
          "product_url": "/products/wns-cblk-m",
          "product_id": 7577008308358,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-cblk-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-WNS32-1.png?v=1775155238&width=400",
          "product_url": "/products/wns-cblk-l",
          "product_id": 7577008341126,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-cblk-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_3D_549ad148-d231-4fb7-9516-68ab4264a600.png?v=1775846492&width=400",
          "product_url": "/products/wns-cblk-xl",
          "product_id": 7577008406662,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-cblk-xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426212998__mg_product_swatches_n7Y4hL-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};

window.MG_SWATCH_SETS["Sizes-WNS-VCHY"] = {
  "meta": {
    "appearance": {
      "border_color": "#969696",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#f5f5f5",
      "gradient_angle": 180,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 6,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#e7e7e7",
      "gradient_angle": 180,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "heading": "<h3>Vintage Cherry Size Options</h3>",
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "8 oz (Bottle)",
          "alt": "8 oz (Bottle)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-WNS08-1.png?v=1775155798&width=400",
          "product_url": "/products/wns-chry-s",
          "product_id": 7577008832646,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-chry-s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "16 oz (Pint)",
          "alt": "16 oz (Pint)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-WNS16-1.png?v=1775155912&width=400",
          "product_url": "/products/wns-chry-m",
          "product_id": 7577008930950,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-chry-m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "32 oz (Quart)",
          "alt": "32 oz (Quart)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-WNS32-1_ea0f6771-ac04-41c2-bd67-a081ea418480.png?v=1775156059&width=400",
          "product_url": "/products/wns-chry-l",
          "product_id": 7577009029254,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-chry-l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "128 oz (Gallon)",
          "alt": "128 oz (Gallon)",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front_3D_664dc2a9-bb15-40fa-b070-296e0f12856c.png?v=1775846228&width=400",
          "product_url": "/products/wns-chry-xl",
          "product_id": 7577009062022,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/wns-chry-xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18541426212998__mg_product_swatches_3m6KBw-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>8 oz – 25 square feet</li>\n    <li>16 oz – 50 square feet</li>\n    <li>32 oz – 100 square feet</li>\n    <li>Gallon – 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    },
    {
      "preset_button": true,
      "preset_button_text": "<h3>More Help on Sizing</h3>",
      "preset_button_set": "Help-WNS-Sizes",
      "preset_button_style": "dropdown_box",
      "preset_button_subtext": "<p>Select</p>",
      "preset_button_image_height_mobile": "0",
      "preset_button_image_height_desktop": "0",
      "preset_button_width_percent": 100,
      "preset_button_max_width_px": "0",
      "heading": "<h3>More Help on Sizing</h3>",
      "subheading": "<p>Select</p>",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};





// ✅ OPTIONAL: paste these ONCE after adding/updating one or more sets (helps previews refresh):
document.dispatchEvent(new CustomEvent("media_gallery_sets_ready"));
document.dispatchEvent(new CustomEvent("vimeo_sets_ready"));

